import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '../botao/botao.component';
import { CampoTextoComponent } from '../campo-texto/campo-texto.component';
import { ContatoService } from '../../../service/contato.service';
import { MsgService } from '../../../service/msg.service';
import { ModalEditarContatoData } from './models/modal-editar-contato-data.model';

@Component({
  selector: 'app-modal-editar-contato',
  standalone: true,
  imports: [FormsModule, MatIconModule, ButtonComponent, CampoTextoComponent],
  templateUrl: './modal-editar-contato.component.html',
  styleUrl: './modal-editar-contato.component.css'
})
export class ModalEditarContatoComponent {
  private readonly data = inject<ModalEditarContatoData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<ModalEditarContatoComponent, string>>(MatDialogRef);
  private readonly contatoService = inject(ContatoService);
  private readonly msgService = inject(MsgService);

  nome = this.data.nome ?? '';
  erroNome = '';
  salvando = signal(false);

  cancelar() {
    this.dialogRef.close();
  }

  salvar() {
    const nome = this.nome.trim();
    if (!nome) {
      this.erroNome = 'Informe o nome do contato.';
      return;
    }
    if (this.salvando()) {
      return;
    }

    this.erroNome = '';
    this.salvando.set(true);
    this.contatoService.editarNomeContato({ idContato: this.data.contatoId, nome }).subscribe({
      next: res => {
        this.msgService.msgSucesso('Contato atualizado com sucesso.');
        this.dialogRef.close(res?.nome ?? nome);
      },
      error: () => this.salvando.set(false)
    });
  }
}
